import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import { CSpacing, NativeProps } from '@/src/components/interfaces';
import { CBox } from '@/src/components/c-box/CBox';

export enum CPaperColor {
  White = 'white',
  Gray = 'gray',
}

export interface CPaperProps extends NativeProps {
  padding?: CSpacing;
  color?: CPaperColor;
  fullHeight?: boolean;
}

export function CPaper(props: PropsWithChildren<CPaperProps>): React.JSX.Element {
  const padding = props.padding ?? CSpacing.Lg;
  const color = props.color ?? CPaperColor.White;

  return (
    <CBox
      id={props.id}
      as="section"
      onClick={props.onClick}
      style={props.style}
      data-test-selector={props.testSelector}
      fullHeight={props.fullHeight}
      class={classNames('c-paper', props.class, {
        [`c-padding--${padding}`]: padding,
        [`c-paper--background-${color}`]: color,
      })}
    >
      {props.children}
    </CBox>
  );
}